
import React from 'react';
import SEO from '../components/SEO';
import WorkflowTimeline from '../components/WorkflowTimeline';
import AIImage from '../components/AIImage';
import { Link } from 'react-router';

const PublicPortal: React.FC = () => {
  return (
    <div className="animate-fade-in-up">
      <SEO
        title="Public eAIP Portal"
        description="The customer-facing digital publication portal for Civil Aviation Authorities."
      />
      <section className="py-24 px-4 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          <div>
            <h1 className="text-5xl lg:text-7xl font-bold font-heading mb-8">Public Facing. <br /><span className="text-accent">Global Reach.</span></h1>
            <p className="text-xl text-slate-400 mb-10 leading-relaxed">
              AviaGov isn't just an internal tool. Our Public Portal module provides a high-performance, mobile-optimized interface for pilots and operators to consume AIP, NOTAM, and Charts on any device.
            </p>
            <div className="grid grid-cols-2 gap-6 mb-10">
              <div className="space-y-2">
                <div className="text-white font-bold">Custom Domains</div>
                <p className="text-slate-500 text-xs">Host on your own .gov or .aero domain seamlessly.</p>
              </div>
              <div className="space-y-2">
                <div className="text-white font-bold">Multi-Lingual</div>
                <p className="text-slate-500 text-xs">Full support for ICAO languages + regional dialects.</p>
              </div>
              <div className="space-y-2">
                <div className="text-white font-bold">PWA Enabled</div>
                <p className="text-slate-500 text-xs">Users can install the portal as a desktop or mobile app.</p>
              </div>
              <div className="space-y-2">
                <div className="text-white font-bold">Encrypted Delivery</div>
                <p className="text-slate-500 text-xs">High-speed CDN delivery with end-to-end security.</p>
              </div>
            </div>
          </div>
          <div className="relative">
             <div className="absolute -inset-10 bg-accent/5 blur-3xl rounded-full"></div>
             <AIImage 
               prompt="A friendly 3D cartoon character holding a futuristic digital tablet displaying a sleek aviation map portal, vibrant colors, clean design."
               alt="Public Portal Interface"
               className="w-full aspect-[4/3] relative z-10"
               aspectRatio="4:3"
             />
          </div>
        </div>

        <div className="mt-32">
          <h2 className="text-3xl font-bold font-heading mb-16 text-center text-white">Data Integrity Workflow</h2>
          <WorkflowTimeline />
        </div>
      </section>
    </div>
  );
};

export default PublicPortal;
